import { render } from "./App.vue?vue&type=template&id=0d19163b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0d19163b&lang=css"

import exportComponent from "C:\\Users\\brinl\\Desktop\\FnixApp\\LatestsUpload\\fnx\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__